const company = {
  state: {
    company: null, // main company logged in
    companyDID: null, // used in cases where company under review is different to main
    companyAccess: null
  },
  mutations: {
    changeCompany(state, payload) {
      state.company = payload;
    },
    changeCompanyDID(state, payload) {
      state.companyDID = payload;
    },
    changeCompanyAccess(state, payload) {
      state.companyAccess = payload;
    }
  },
  actions: {
    changeCompany({ commit }, payload) {
      commit("changeCompany", payload);
    },
    changeCompanyDID({ commit }, payload) {
      commit("changeCompanyDID", payload);
    },
    changeCompanyAccess({ commit }, payload) {
      commit("changeCompanyAccess", payload);
    }
  },
  getters: {
    getCompany: state => {
      return state.company;
    },
    getCompanyDID: state => {
      return state.companyDID;
    },
    getCompanyAccess: state => {
      return state.companyAccess;
    }
  }
};
export default company;
